<template>
    <div v-if="post" class="publish-feed row" :class="{'pinned': post.pinned}">
        <div class="d-flex justify-content-start align-items-center community-type" v-if="$route.name == 'LmsMyFeedSocial' && post.community_name">
            Publicado na comunidade&nbsp;<span class="community-name" @click="goToCommunity(post.community_slug)">{{ post.community_name }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 2px;">
            <div>
                <img :src="post.profile_photo_url" class="profile-img">
                <span class="nickname">{{ post.nickname }}</span>
            </div>
            <div>
                <div style="position: relative;" class="d-flex">
                    <div v-if="post.pinned" class="more-actions" style="margin-right: 20px;">
                        <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1221 7.92041C11.1221 8.48291 11.2627 8.99854 11.5439 9.46729C11.8252 9.90479 12.1846 10.2642 12.6221 10.5454C13.0908 10.7954 13.5908 10.9204 14.1221 10.9204V12.936H8.12207V19.9204L7.09082 20.9048L6.10645 19.9204V12.936H0.15332V10.9204C0.68457 10.9204 1.16895 10.7954 1.60645 10.5454C2.0752 10.2642 2.4502 9.90479 2.73145 9.46729C3.0127 8.99854 3.15332 8.48291 3.15332 7.92041V2.90479H2.12207C1.87207 2.90479 1.6377 2.81104 1.41895 2.62354C1.23145 2.43604 1.1377 2.20166 1.1377 1.92041C1.1377 1.63916 1.23145 1.40479 1.41895 1.21729C1.6377 1.02979 1.87207 0.936035 2.12207 0.936035H12.1533C12.4033 0.936035 12.6221 1.02979 12.8096 1.21729C13.0283 1.40479 13.1377 1.63916 13.1377 1.92041C13.1377 2.20166 13.0283 2.43604 12.8096 2.62354C12.6221 2.81104 12.4033 2.90479 12.1533 2.90479H11.1221V7.92041Z" fill="var(--buttons_color)"/>
                        </svg>
                    </div>
                    <div v-if="!post.is_owner && !post.pinned" class="more-actions" style="margin-right: 20px;">
                        <svg @click="handleAction('send', parseInt(post.user_id))" v-if="!post.is_friend && !post.is_requester && !post.is_requested" width="23" height="16" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9844 5.92041H24V7.93604H21.9844V9.90479H20.0156V7.93604H18V5.92041H20.0156V3.90479H21.9844V5.92041ZM8.01562 8.92041C7.26562 8.92041 6.57812 8.74854 5.95312 8.40479C5.35938 8.02979 4.875 7.54541 4.5 6.95166C4.15625 6.32666 3.98438 5.65479 3.98438 4.93604C3.98438 4.18604 4.15625 3.51416 4.5 2.92041C4.875 2.29541 5.35938 1.81104 5.95312 1.46729C6.57812 1.09229 7.26562 0.904785 8.01562 0.904785C8.73438 0.904785 9.39062 1.09229 9.98438 1.46729C10.6094 1.81104 11.0938 2.29541 11.4375 2.92041C11.8125 3.51416 12 4.18604 12 4.93604C12 5.65479 11.8125 6.32666 11.4375 6.95166C11.0938 7.54541 10.6094 8.02979 9.98438 8.40479C9.39062 8.74854 8.73438 8.92041 8.01562 8.92041ZM8.01562 9.90479C8.54688 9.90479 9.15625 9.96729 9.84375 10.0923C10.5312 10.186 11.2344 10.3423 11.9531 10.561C12.6719 10.7798 13.3281 11.0454 13.9219 11.3579C14.5469 11.6704 15.0469 12.0454 15.4219 12.4829C15.7969 12.9204 15.9844 13.4048 15.9844 13.936V16.936H0V13.936C0 13.4048 0.1875 12.9204 0.5625 12.4829C0.9375 12.0454 1.42188 11.6704 2.01562 11.3579C2.64062 11.0454 3.3125 10.7798 4.03125 10.561C4.75 10.3423 5.45312 10.186 6.14062 10.0923C6.85938 9.96729 7.48438 9.90479 8.01562 9.90479ZM12.5156 0.95166C13.1719 1.04541 13.7656 1.27979 14.2969 1.65479C14.8281 2.02979 15.2344 2.49854 15.5156 3.06104C15.8281 3.62354 15.9844 4.24854 15.9844 4.93604C15.9844 5.59229 15.8281 6.21729 15.5156 6.81104C15.2344 7.37354 14.8281 7.84229 14.2969 8.21729C13.7656 8.56104 13.1719 8.77979 12.5156 8.87354C12.9844 8.34229 13.3438 7.74854 13.5938 7.09229C13.875 6.40479 14.0156 5.68604 14.0156 4.93604C14.0156 4.18604 13.875 3.46729 13.5938 2.77979C13.3438 2.09229 12.9844 1.48291 12.5156 0.95166ZM16.5469 10.7485C17.1719 10.9673 17.7344 11.2329 18.2344 11.5454C18.7656 11.8579 19.1875 12.2173 19.5 12.6235C19.8438 12.9985 20.0156 13.436 20.0156 13.936V16.936H18V13.936C18 13.2798 17.8594 12.686 17.5781 12.1548C17.3281 11.6235 16.9844 11.1548 16.5469 10.7485Z" fill="currentColor"/>
                        </svg>

                        <svg v-else width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.4688 17.4844L9 14.0156L10.4062 12.6094L12.4688 14.6719L17.5781 9.51562L18.9844 10.9219L12.4688 17.4844ZM10.8281 7.82812C10.0469 8.60938 9.10938 9 8.01562 9C6.92188 9 5.96875 8.60938 5.15625 7.82812C4.375 7.04688 3.98438 6.10938 3.98438 5.01562C3.98438 3.92188 4.375 2.98438 5.15625 2.20312C5.96875 1.39063 6.92188 0.984375 8.01562 0.984375C9.10938 0.984375 10.0469 1.39063 10.8281 2.20312C11.6094 2.98438 12 3.92188 12 5.01562C12 6.10938 11.6094 7.04688 10.8281 7.82812ZM6 14.0156L9 17.0156H0V15C0 13.8125 0.90625 12.8594 2.71875 12.1406C4.5625 11.3906 6.32812 11.0156 8.01562 11.0156C8.48438 11.0156 8.8125 11.0312 9 11.0625L6 14.0156Z" fill="var(--buttons_color)"/>
                        </svg>
                    </div>
                    <div v-if="!post.pinned" class="more-actions" style="margin-right: 5px;" @click.stop="showMoreMenu = !showMoreMenu">
                        <svg width="7" height="18" viewBox="0 0 6 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.59375 13.5156C2 13.1094 2.46875 12.9062 3 12.9062C3.53125 12.9062 4 13.1094 4.40625 13.5156C4.8125 13.9219 5.01562 14.3906 5.01562 14.9219C5.01562 15.4531 4.8125 15.9219 4.40625 16.3281C4 16.7344 3.53125 16.9375 3 16.9375C2.46875 16.9375 2 16.7344 1.59375 16.3281C1.1875 15.9219 0.984375 15.4531 0.984375 14.9219C0.984375 14.3906 1.1875 13.9219 1.59375 13.5156ZM1.59375 7.51562C2 7.10938 2.46875 6.90625 3 6.90625C3.53125 6.90625 4 7.10938 4.40625 7.51562C4.8125 7.92188 5.01562 8.39062 5.01562 8.92188C5.01562 9.45312 4.8125 9.92188 4.40625 10.3281C4 10.7344 3.53125 10.9375 3 10.9375C2.46875 10.9375 2 10.7344 1.59375 10.3281C1.1875 9.92188 0.984375 9.45312 0.984375 8.92188C0.984375 8.39062 1.1875 7.92188 1.59375 7.51562ZM4.40625 4.32812C4 4.73438 3.53125 4.9375 3 4.9375C2.46875 4.9375 2 4.73438 1.59375 4.32812C1.1875 3.92187 0.984375 3.45312 0.984375 2.92188C0.984375 2.39063 1.1875 1.92188 1.59375 1.51562C2 1.10937 2.46875 0.90625 3 0.90625C3.53125 0.90625 4 1.10937 4.40625 1.51562C4.8125 1.92188 5.01562 2.39063 5.01562 2.92188C5.01562 3.45312 4.8125 3.92187 4.40625 4.32812Z" fill="currentColor"/>
                        </svg>
                    </div>

                    <div class="dropdown_menu" v-if="showMoreMenu">
                        <div v-if="!post.is_owner">
                            <button v-if="!post.is_friend && post.is_requested && !post.is_requester" class="dropdown_item" @click="handleAction('accept', parseInt(post.user_id))">
                                <svg width="23" height="16" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.9844 5.92041H24V7.93604H21.9844V9.90479H20.0156V7.93604H18V5.92041H20.0156V3.90479H21.9844V5.92041ZM8.01562 8.92041C7.26562 8.92041 6.57812 8.74854 5.95312 8.40479C5.35938 8.02979 4.875 7.54541 4.5 6.95166C4.15625 6.32666 3.98438 5.65479 3.98438 4.93604C3.98438 4.18604 4.15625 3.51416 4.5 2.92041C4.875 2.29541 5.35938 1.81104 5.95312 1.46729C6.57812 1.09229 7.26562 0.904785 8.01562 0.904785C8.73438 0.904785 9.39062 1.09229 9.98438 1.46729C10.6094 1.81104 11.0938 2.29541 11.4375 2.92041C11.8125 3.51416 12 4.18604 12 4.93604C12 5.65479 11.8125 6.32666 11.4375 6.95166C11.0938 7.54541 10.6094 8.02979 9.98438 8.40479C9.39062 8.74854 8.73438 8.92041 8.01562 8.92041ZM8.01562 9.90479C8.54688 9.90479 9.15625 9.96729 9.84375 10.0923C10.5312 10.186 11.2344 10.3423 11.9531 10.561C12.6719 10.7798 13.3281 11.0454 13.9219 11.3579C14.5469 11.6704 15.0469 12.0454 15.4219 12.4829C15.7969 12.9204 15.9844 13.4048 15.9844 13.936V16.936H0V13.936C0 13.4048 0.1875 12.9204 0.5625 12.4829C0.9375 12.0454 1.42188 11.6704 2.01562 11.3579C2.64062 11.0454 3.3125 10.7798 4.03125 10.561C4.75 10.3423 5.45312 10.186 6.14062 10.0923C6.85938 9.96729 7.48438 9.90479 8.01562 9.90479ZM12.5156 0.95166C13.1719 1.04541 13.7656 1.27979 14.2969 1.65479C14.8281 2.02979 15.2344 2.49854 15.5156 3.06104C15.8281 3.62354 15.9844 4.24854 15.9844 4.93604C15.9844 5.59229 15.8281 6.21729 15.5156 6.81104C15.2344 7.37354 14.8281 7.84229 14.2969 8.21729C13.7656 8.56104 13.1719 8.77979 12.5156 8.87354C12.9844 8.34229 13.3438 7.74854 13.5938 7.09229C13.875 6.40479 14.0156 5.68604 14.0156 4.93604C14.0156 4.18604 13.875 3.46729 13.5938 2.77979C13.3438 2.09229 12.9844 1.48291 12.5156 0.95166ZM16.5469 10.7485C17.1719 10.9673 17.7344 11.2329 18.2344 11.5454C18.7656 11.8579 19.1875 12.2173 19.5 12.6235C19.8438 12.9985 20.0156 13.436 20.0156 13.936V16.936H18V13.936C18 13.2798 17.8594 12.686 17.5781 12.1548C17.3281 11.6235 16.9844 11.1548 16.5469 10.7485Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Aceitar amizade
                            </button>
                            <button v-if="!post.is_friend && post.is_requested && !post.is_requester" class="dropdown_item" @click="handleAction('reject', parseInt(post.user_id))">
                                <svg width="21" height="21" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6797 4.17969C10.6797 4.77865 10.5234 5.33854 10.2109 5.85938C9.92448 6.35417 9.52083 6.75781 9 7.07031C8.50521 7.35677 7.94531 7.5 7.32031 7.5C6.72135 7.5 6.16146 7.35677 5.64062 7.07031C5.14583 6.75781 4.74219 6.35417 4.42969 5.85938C4.14323 5.33854 4 4.77865 4 4.17969C4 3.55469 4.14323 2.99479 4.42969 2.5C4.74219 1.97917 5.14583 1.57552 5.64062 1.28906C6.16146 0.976562 6.72135 0.820312 7.32031 0.820312C7.94531 0.820312 8.50521 0.976562 9 1.28906C9.52083 1.57552 9.92448 1.97917 10.2109 2.5C10.5234 2.99479 10.6797 3.55469 10.6797 4.17969ZM13.1797 5.82031H18.1797V7.5H13.1797V5.82031ZM0.679688 12.5C0.679688 12.0573 0.835938 11.6667 1.14844 11.3281C1.46094 10.9635 1.86458 10.651 2.35938 10.3906C2.88021 10.1042 3.4401 9.88281 4.03906 9.72656C4.63802 9.54427 5.22396 9.41406 5.79688 9.33594C6.36979 9.23177 6.8776 9.17969 7.32031 9.17969C7.76302 9.17969 8.27083 9.23177 8.84375 9.33594C9.44271 9.41406 10.0417 9.54427 10.6406 9.72656C11.2396 9.88281 11.7865 10.1042 12.2812 10.3906C12.8021 10.651 13.2188 10.9635 13.5312 11.3281C13.8438 11.6667 14 12.0573 14 12.5V14.1797H0.679688V12.5Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Rejeitar amizade
                            </button>
                            <button v-if="!post.is_friend && post.is_requester && !post.is_requested" class="dropdown_item" @click="handleAction('cancel', parseInt(post.user_id))">
                                <svg width="21" height="21" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6797 4.17969C10.6797 4.77865 10.5234 5.33854 10.2109 5.85938C9.92448 6.35417 9.52083 6.75781 9 7.07031C8.50521 7.35677 7.94531 7.5 7.32031 7.5C6.72135 7.5 6.16146 7.35677 5.64062 7.07031C5.14583 6.75781 4.74219 6.35417 4.42969 5.85938C4.14323 5.33854 4 4.77865 4 4.17969C4 3.55469 4.14323 2.99479 4.42969 2.5C4.74219 1.97917 5.14583 1.57552 5.64062 1.28906C6.16146 0.976562 6.72135 0.820312 7.32031 0.820312C7.94531 0.820312 8.50521 0.976562 9 1.28906C9.52083 1.57552 9.92448 1.97917 10.2109 2.5C10.5234 2.99479 10.6797 3.55469 10.6797 4.17969ZM13.1797 5.82031H18.1797V7.5H13.1797V5.82031ZM0.679688 12.5C0.679688 12.0573 0.835938 11.6667 1.14844 11.3281C1.46094 10.9635 1.86458 10.651 2.35938 10.3906C2.88021 10.1042 3.4401 9.88281 4.03906 9.72656C4.63802 9.54427 5.22396 9.41406 5.79688 9.33594C6.36979 9.23177 6.8776 9.17969 7.32031 9.17969C7.76302 9.17969 8.27083 9.23177 8.84375 9.33594C9.44271 9.41406 10.0417 9.54427 10.6406 9.72656C11.2396 9.88281 11.7865 10.1042 12.2812 10.3906C12.8021 10.651 13.2188 10.9635 13.5312 11.3281C13.8438 11.6667 14 12.0573 14 12.5V14.1797H0.679688V12.5Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Cancelar pedido
                            </button>
                            <button v-if="post.is_friend && !post.is_requested && !post.is_requester" class="dropdown_item" @click="handleAction('remove', parseInt(post.user_id))">
                                <svg width="21" height="21" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6797 4.17969C10.6797 4.77865 10.5234 5.33854 10.2109 5.85938C9.92448 6.35417 9.52083 6.75781 9 7.07031C8.50521 7.35677 7.94531 7.5 7.32031 7.5C6.72135 7.5 6.16146 7.35677 5.64062 7.07031C5.14583 6.75781 4.74219 6.35417 4.42969 5.85938C4.14323 5.33854 4 4.77865 4 4.17969C4 3.55469 4.14323 2.99479 4.42969 2.5C4.74219 1.97917 5.14583 1.57552 5.64062 1.28906C6.16146 0.976562 6.72135 0.820312 7.32031 0.820312C7.94531 0.820312 8.50521 0.976562 9 1.28906C9.52083 1.57552 9.92448 1.97917 10.2109 2.5C10.5234 2.99479 10.6797 3.55469 10.6797 4.17969ZM13.1797 5.82031H18.1797V7.5H13.1797V5.82031ZM0.679688 12.5C0.679688 12.0573 0.835938 11.6667 1.14844 11.3281C1.46094 10.9635 1.86458 10.651 2.35938 10.3906C2.88021 10.1042 3.4401 9.88281 4.03906 9.72656C4.63802 9.54427 5.22396 9.41406 5.79688 9.33594C6.36979 9.23177 6.8776 9.17969 7.32031 9.17969C7.76302 9.17969 8.27083 9.23177 8.84375 9.33594C9.44271 9.41406 10.0417 9.54427 10.6406 9.72656C11.2396 9.88281 11.7865 10.1042 12.2812 10.3906C12.8021 10.651 13.2188 10.9635 13.5312 11.3281C13.8438 11.6667 14 12.0573 14 12.5V14.1797H0.679688V12.5Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Desfazer amizade
                            </button>
                            <button class="dropdown_item" @click="handleAction('block', parseInt(post.user_id))">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 15.6797C10.8229 15.6797 12.3854 15.0286 13.6875 13.7266C15.0156 12.3984 15.6797 10.8229 15.6797 9C15.6797 8.375 15.5365 7.65885 15.25 6.85156C14.9896 6.04427 14.6641 5.39323 14.2734 4.89844L4.89844 14.2734C6.07031 15.2109 7.4375 15.6797 9 15.6797ZM2.32031 9C2.32031 9.625 2.45052 10.3411 2.71094 11.1484C2.9974 11.9557 3.33594 12.6068 3.72656 13.1016L13.1016 3.72656C11.9297 2.78906 10.5625 2.32031 9 2.32031C7.17708 2.32031 5.60156 2.98438 4.27344 4.3125C2.97135 5.61458 2.32031 7.17708 2.32031 9ZM3.10156 3.14062C4.74219 1.5 6.70833 0.679688 9 0.679688C11.2917 0.679688 13.2448 1.5 14.8594 3.14062C16.5 4.75521 17.3203 6.70833 17.3203 9C17.3203 11.2917 16.5 13.2578 14.8594 14.8984C13.2448 16.513 11.2917 17.3203 9 17.3203C6.70833 17.3203 4.74219 16.513 3.10156 14.8984C1.48698 13.2578 0.679688 11.2917 0.679688 9C0.679688 6.70833 1.48698 4.75521 3.10156 3.14062Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Bloquear Usuário
                            </button>
                            <button class="dropdown_item" @click="handleAction('report', parseInt(post.id))">
                                <svg width="15" height="18" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.99219 2H12.6797V10.3203H6.82031L6.50781 8.67969H1.82031V14.5H0.179688V0.320312H7.67969L7.99219 2Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Denunciar Publicação
                            </button>
                        </div>
                        <div v-else-if="post.is_owner">
                            <button class="dropdown_item" @click="handleAction('delete', parseInt(post.id))">
                                <svg width="18" height="18" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.65625 1.28125L5.9375 5L9.65625 8.71875L8.71875 9.65625L5 5.9375L1.28125 9.65625L0.34375 8.71875L4.0625 5L0.34375 1.28125L1.28125 0.34375L5 4.0625L8.71875 0.34375L9.65625 1.28125Z" fill="currentColor"/>
                                </svg>
                                &nbsp;
                                Excluir Publicação
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">

            <div v-if="post.file_type == 'image' && post.photo_url" class="post-img-container">
                <div class="post-img-back" :style="{ 'background-image': `url('${post.photo_url}')` }"></div>
                <img class="post-img" :src="post.photo_url">
            </div>

            <div v-else-if="post.file_type == 'video'" class="post-img-container">
                <video class="post-img" :src="post.photo_url" controls></video>
            </div>

            <div v-else-if="post.file_type == 'link'" class="post-document-container flex-column" style="padding: 0 !important;" id="link-container">
                <div id="link-preview" class="post-link">
                    <div id="link-preview-back" class="post-img-back" :style="`background: url('${post.link_data.image}');`"></div>
                    <img id="link-preview-image" style="position: relative; z-index: 0;" class="post-link-img" :src="post.link_data.image" alt="">
                </div>

                <div class="d-flex justify-content-between" style="border-top: 1px solid #E1E1E1; background: #F6F6F6; z-index: 2; position: relative; padding: 15px 25px; margin: 0 !important;">
                    <div style="max-width: 90%; text-wrap: wrap;">
                        <span class="link-url" id="link-preview-url"> {{ getParsedUrl() }}</span>
                        <br>
                        <span class="link-title" id="link-preview-title" v-html="post.link_data.title"></span>
                        <br>
                        <span v-if="!isMobile" class="link-desc" id="link-preview-desc" v-html="post.link_data.description"></span>
                    </div>
                    <div @click="openLink(post.link)" class="open-link-preview">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.0156 0H18V6.98438H15.9844V3.42188L6.1875 13.2188L4.78125 11.8125L14.5781 2.01562H11.0156V0ZM15.9844 15.9844V9H18V15.9844C18 16.5156 17.7969 16.9844 17.3906 17.3906C16.9844 17.7969 16.5156 18 15.9844 18H2.01562C1.45312 18 0.96875 17.8125 0.5625 17.4375C0.1875 17.0312 0 16.5469 0 15.9844V2.01562C0 1.45312 0.1875 0.984375 0.5625 0.609375C0.96875 0.203125 1.45312 0 2.01562 0H9V2.01562H2.01562V15.9844H15.9844Z" fill="currentColor"/>
                        </svg>
                    </div>
                </div>
            </div>

            <div v-else-if="post.file_type == 'file'" class="post-img-container" id="document-container" style="padding: 0 !important;">
                <div class="post-document d-flex justify-content-between" id="document-preview">
                    <div class="d-flex align-items-center">
                        <svg width="42" height="42" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.9688 0C33.0938 0 34.0312 0.40625 34.7812 1.21875C35.5938 1.96875 36 2.90625 36 4.03125V31.9688C36 33.0938 35.5938 34.0625 34.7812 34.875C34.0312 35.625 33.0938 36 31.9688 36H4.03125C2.90625 36 1.9375 35.625 1.125 34.875C0.375 34.0625 0 33.0938 0 31.9688V4.03125C0 2.90625 0.375 1.96875 1.125 1.21875C1.9375 0.40625 2.90625 0 4.03125 0H31.9688ZM22.0312 28.0312V24H7.96875V28.0312H22.0312ZM28.0312 19.9688V16.0312H7.96875V19.9688H28.0312ZM28.0312 12V7.96875H7.96875V12H28.0312Z" fill="var(--buttons_color)"/>
                        </svg>

                        <div style="margin-left: 15px;">
                            <span id="document-preview-name"> {{  getFileName() }}</span>
                            <br>
                            <span id="document-preview-size" v-html="post.file_size"></span>
                        </div>
                    </div>

                    <div class="d-flex align-items-center document-download" @click="downloadFile(post.photo_url)">
                        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.179688 14.6797V13H11.8203V14.6797H0.179688ZM11.8203 5.5L6 11.3203L0.179688 5.5H3.5V0.5H8.5V5.5H11.8203Z" fill="currentColor"/>
                        </svg>
                        &nbsp;
                        <span>Download</span>
                    </div>
                </div>
            </div>

            <div>
                <span class="post-data" v-text="post.data"></span>
                <br>
                <div class="post-details" v-html="post.detail"></div>
            </div>
        </div>

        <div class="d-flex justify-content-between" style="margin: 20px 0;">
            <div class="d-flex align-items-center" style="position: relative;">
                <div v-if="showReactMenu" style="background-color:white; box-shadow: 5px 5px 5px #34343440; max-width: 400px; border-radius: 15px; color: #000; position: absolute; padding: 10px; justify-content: center; bottom: 100%">
                    <div class="reactPostList">
                        <div @click="reactPost(post.id, 'heart')" title="Amei">
                            <svg width="20" height="20" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 15.7734L7.78906 14.6797C6.40885 13.4297 5.40625 12.5052 4.78125 11.9062C4.15625 11.3073 3.45312 10.5651 2.67188 9.67969C1.91667 8.79427 1.39583 8 1.10938 7.29688C0.822917 6.56771 0.679688 5.82552 0.679688 5.07031C0.679688 3.79427 1.10938 2.71354 1.96875 1.82812C2.85417 0.942708 3.94792 0.5 5.25 0.5C6.76042 0.5 8.01042 1.08594 9 2.25781C9.98958 1.08594 11.2396 0.5 12.75 0.5C14.0521 0.5 15.1328 0.942708 15.9922 1.82812C16.8776 2.71354 17.3203 3.79427 17.3203 5.07031C17.3203 6.08594 16.9818 7.14062 16.3047 8.23438C15.6276 9.32812 14.8854 10.2786 14.0781 11.0859C13.2969 11.8932 12.0078 13.1042 10.2109 14.7188L9 15.7734Z" :fill="((post.is_reacted == 'heart') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                            </svg>
                        </div>
                        <div @click="reactPost(post.id, 'lol')" title="LoL">
                            <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.82031 10.6797H13.1797C12.8411 11.6693 12.2943 12.4766 11.5391 13.1016C10.7839 13.7005 9.9375 14 9 14C8.0625 14 7.21615 13.7005 6.46094 13.1016C5.70573 12.4766 5.15885 11.6693 4.82031 10.6797ZM4.27344 13.7266C5.60156 15.0286 7.17708 15.6797 9 15.6797C10.8229 15.6797 12.3854 15.0286 13.6875 13.7266C15.0156 12.3984 15.6797 10.8229 15.6797 9C15.6797 7.17708 15.0156 5.61458 13.6875 4.3125C12.3854 2.98438 10.8229 2.32031 9 2.32031C7.17708 2.32031 5.60156 2.98438 4.27344 4.3125C2.97135 5.61458 2.32031 7.17708 2.32031 9C2.32031 10.8229 2.97135 12.3984 4.27344 13.7266ZM3.10156 3.14062C4.74219 1.5 6.70833 0.679688 9 0.679688C11.2917 0.679688 13.2448 1.5 14.8594 3.14062C16.5 4.75521 17.3203 6.70833 17.3203 9C17.3203 11.2917 16.5 13.2578 14.8594 14.8984C13.2448 16.513 11.2917 17.3203 9 17.3203C6.70833 17.3203 4.74219 16.513 3.10156 14.8984C1.48698 13.2578 0.679688 11.2917 0.679688 9C0.679688 6.70833 1.48698 4.75521 3.10156 3.14062ZM5.17188 7.82812C4.9375 7.56771 4.82031 7.26823 4.82031 6.92969C4.82031 6.59115 4.9375 6.30469 5.17188 6.07031C5.43229 5.8099 5.73177 5.67969 6.07031 5.67969C6.40885 5.67969 6.69531 5.8099 6.92969 6.07031C7.1901 6.30469 7.32031 6.59115 7.32031 6.92969C7.32031 7.26823 7.1901 7.56771 6.92969 7.82812C6.69531 8.0625 6.40885 8.17969 6.07031 8.17969C5.73177 8.17969 5.43229 8.0625 5.17188 7.82812ZM11.0312 7.82812C10.7969 7.56771 10.6797 7.26823 10.6797 6.92969C10.6797 6.59115 10.7969 6.30469 11.0312 6.07031C11.2917 5.8099 11.5911 5.67969 11.9297 5.67969C12.2682 5.67969 12.5547 5.8099 12.7891 6.07031C13.0495 6.30469 13.1797 6.59115 13.1797 6.92969C13.1797 7.26823 13.0495 7.56771 12.7891 7.82812C12.5547 8.0625 12.2682 8.17969 11.9297 8.17969C11.5911 8.17969 11.2917 8.0625 11.0312 7.82812Z" :fill="((post.is_reacted == 'lol') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                            </svg>
                        </div>
                        <div @click="reactPost(post.id, 'wow')" title="Uau">
                            <svg width="20" height="20" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="M20.979 0C9.387 0 0 9.408 0 21C0 32.592 9.387 42 20.979 42C32.592 42 42 32.592 42 21C42 9.408 32.592 0 20.979 0ZM21 37.8C11.718 37.8 4.2 30.282 4.2 21C4.2 11.718 11.718 4.2 21 4.2C30.282 4.2 37.8 11.718 37.8 21C37.8 30.282 30.282 37.8 21 37.8ZM28.35 18.9C30.093 18.9 31.5 17.493 31.5 15.75C31.5 14.007 30.093 12.6 28.35 12.6C26.607 12.6 25.2 14.007 25.2 15.75C25.2 17.493 26.607 18.9 28.35 18.9ZM13.65 18.9C15.393 18.9 16.8 17.493 16.8 15.75C16.8 14.007 15.393 12.6 13.65 12.6C11.907 12.6 10.5 14.007 10.5 15.75C10.5 17.493 11.907 18.9 13.65 18.9Z" :fill="((post.is_reacted == 'wow') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                                    <path d="M21.0002 35.7001C24.4796 35.7001 27.3002 32.8795 27.3002 29.4001C27.3002 25.9207 24.4796 23.1001 21.0002 23.1001C17.5208 23.1001 14.7002 25.9207 14.7002 29.4001C14.7002 32.8795 17.5208 35.7001 21.0002 35.7001Z" :fill="((post.is_reacted == 'wow') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                                </g>
                            </svg>
                        </div>
                        <div @click="reactPost(post.id, 'cry')" title="Triste">
                            <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.38281 11.5C7.16406 10.9531 8.03646 10.6797 9 10.6797C9.96354 10.6797 10.8229 10.9531 11.5781 11.5C12.3594 12.0208 12.9193 12.7109 13.2578 13.5703H11.8906C11.2396 12.4766 10.276 11.9297 9 11.9297C7.72396 11.9297 6.76042 12.4766 6.10938 13.5703H4.74219C5.08073 12.7109 5.6276 12.0208 6.38281 11.5ZM4.27344 13.7266C5.60156 15.0286 7.17708 15.6797 9 15.6797C10.8229 15.6797 12.3854 15.0286 13.6875 13.7266C15.0156 12.3984 15.6797 10.8229 15.6797 9C15.6797 7.17708 15.0156 5.61458 13.6875 4.3125C12.3854 2.98438 10.8229 2.32031 9 2.32031C7.17708 2.32031 5.60156 2.98438 4.27344 4.3125C2.97135 5.61458 2.32031 7.17708 2.32031 9C2.32031 10.8229 2.97135 12.3984 4.27344 13.7266ZM3.10156 3.14062C4.74219 1.5 6.70833 0.679688 9 0.679688C11.2917 0.679688 13.2448 1.5 14.8594 3.14062C16.5 4.75521 17.3203 6.70833 17.3203 9C17.3203 11.2917 16.5 13.2578 14.8594 14.8984C13.2448 16.513 11.2917 17.3203 9 17.3203C6.70833 17.3203 4.74219 16.513 3.10156 14.8984C1.48698 13.2578 0.679688 11.2917 0.679688 9C0.679688 6.70833 1.48698 4.75521 3.10156 3.14062ZM5.17188 7.82812C4.9375 7.56771 4.82031 7.26823 4.82031 6.92969C4.82031 6.59115 4.9375 6.30469 5.17188 6.07031C5.43229 5.8099 5.73177 5.67969 6.07031 5.67969C6.40885 5.67969 6.69531 5.8099 6.92969 6.07031C7.1901 6.30469 7.32031 6.59115 7.32031 6.92969C7.32031 7.26823 7.1901 7.56771 6.92969 7.82812C6.69531 8.0625 6.40885 8.17969 6.07031 8.17969C5.73177 8.17969 5.43229 8.0625 5.17188 7.82812ZM11.0312 7.82812C10.7969 7.56771 10.6797 7.26823 10.6797 6.92969C10.6797 6.59115 10.7969 6.30469 11.0312 6.07031C11.2917 5.8099 11.5911 5.67969 11.9297 5.67969C12.2682 5.67969 12.5547 5.8099 12.7891 6.07031C13.0495 6.30469 13.1797 6.59115 13.1797 6.92969C13.1797 7.26823 13.0495 7.56771 12.7891 7.82812C12.5547 8.0625 12.2682 8.17969 11.9297 8.17969C11.5911 8.17969 11.2917 8.0625 11.0312 7.82812Z" :fill="((post.is_reacted == 'cry') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                            </svg>
                        </div>
                        <div @click="reactPost(post.id, 'pray')" title="Amém">
                            <svg width="20" height="20" viewBox="0 0 36 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.9968 1.28123C20.0001 -0.932971 23.4026 -0.0884525 24.1767 2.59945C24.3945 3.35881 24.4211 4.17671 24.5132 4.97155C24.8143 7.57608 25.1048 10.1824 25.3988 12.7887C25.6858 15.3435 25.9709 17.9002 26.2543 20.455C26.3589 21.3865 26.458 22.3161 26.5679 23.2476C26.5785 23.3434 26.6157 23.4499 26.6741 23.5261C27.4429 24.5002 28.2169 25.4689 29.0104 26.466C29.6233 26.0224 30.0732 26.262 30.5337 26.7286C32.188 28.3981 33.8689 30.041 35.5375 31.6963C36.1503 32.3031 36.1539 32.6899 35.5499 33.2949C33.1463 35.7078 30.7409 38.1207 28.332 40.5301C27.7333 41.1297 27.3738 41.1297 26.7769 40.5354C25.0729 38.8428 23.3708 37.1484 21.6721 35.4523C21.0912 34.8721 21.0876 34.5102 21.6615 33.9354C21.9856 33.6107 22.3275 33.3037 22.6321 33.0181C21.0362 31.4302 19.4882 29.8884 17.9525 28.3591C16.4966 29.8387 14.975 31.3876 13.3915 32.9968C13.6696 33.2665 14.031 33.5965 14.3711 33.946C14.867 34.457 14.8688 34.8473 14.3657 35.36C12.637 37.1236 10.9029 38.8818 9.16535 40.6365C8.68357 41.1226 8.24253 41.1209 7.75366 40.633C5.29694 38.1757 2.84199 35.7167 0.392342 33.2541C-0.133719 32.7254 -0.130177 32.3421 0.399427 31.8063C2.09806 30.0854 3.802 28.3679 5.50418 26.6505C6.01607 26.1342 6.23924 26.1023 6.94597 26.4536C7.72178 25.4813 8.50999 24.502 9.28402 23.512C9.36196 23.4126 9.38498 23.2582 9.39915 23.1252C9.71798 20.3166 10.0279 17.508 10.3485 14.6995C10.6709 11.875 11.0021 9.05044 11.3298 6.22591C11.4396 5.27849 11.5601 4.33284 11.6557 3.38365C11.8116 1.84542 12.5821 0.754291 14.031 0.236225C15.4781 -0.280066 16.7711 0.0588056 17.8533 1.1659C17.887 1.20139 17.9295 1.228 17.9968 1.283V1.28123ZM17.1749 14.7332C17.1749 14.538 17.1749 14.3713 17.1749 14.2027C17.1749 10.7767 17.1749 7.34898 17.1749 3.923C17.1749 3.78639 17.1803 3.64978 17.1679 3.51494C17.0793 2.47526 16.2769 1.69462 15.2691 1.65736C14.3161 1.62365 13.4217 2.35639 13.2977 3.30736C13.1436 4.48897 13.0178 5.67414 12.8832 6.85753C12.5963 9.39463 12.3146 11.9317 12.0259 14.4688C11.7372 17.0059 11.3918 19.5378 11.1669 22.0802C11.0517 23.3771 10.7772 24.5215 9.82602 25.4831C9.17598 26.1395 8.657 26.9273 8.10791 27.621C9.48417 29.0013 10.8179 30.3373 12.157 31.6804C12.1765 31.6679 12.2261 31.6466 12.2615 31.6129C13.8361 30.0339 15.4161 28.4584 16.9766 26.8652C17.1076 26.7321 17.1679 26.4766 17.1679 26.2779C17.1803 23.1411 17.1767 20.0044 17.1749 16.8675C17.1749 16.7185 17.1625 16.5695 17.1555 16.4205C16.1264 16.5056 15.5454 17.1372 15.5418 18.1752C15.5348 20.3911 15.5401 22.6071 15.5401 24.8231C15.5401 25.0041 15.5401 25.1832 15.5401 25.3536H13.9105C13.9105 22.9424 13.9105 20.5739 13.9105 18.2053C13.9105 16.2288 15.1256 14.9124 17.1767 14.7314L17.1749 14.7332ZM27.8626 27.637C27.0656 26.6363 26.2402 25.641 25.4661 24.6066C25.2252 24.2837 25.0269 23.8668 24.9737 23.4711C24.6974 21.3616 24.4742 19.245 24.2351 17.1301C23.7179 12.5633 23.2043 7.99479 22.6853 3.428C22.5418 2.17187 21.3498 1.38768 20.163 1.75849C19.3234 2.02106 18.8062 2.77155 18.8062 3.76333C18.8027 7.29221 18.8045 10.8211 18.8062 14.3517C18.8062 14.4813 18.8275 14.6108 18.8381 14.735C20.8786 14.9177 22.0707 16.2288 22.0707 18.255C22.0707 20.2155 22.0707 22.176 22.0707 24.1365C22.0707 24.541 22.0707 24.9455 22.0707 25.3624H20.4411C20.4411 25.1442 20.4411 24.9579 20.4411 24.7734C20.4411 22.5734 20.4464 20.3752 20.4393 18.1752C20.4358 17.1425 19.8407 16.4985 18.8328 16.4222C18.824 16.5038 18.8062 16.5855 18.8062 16.6671C18.8062 19.9068 18.8009 23.1465 18.8169 26.3844C18.8169 26.5724 18.9409 26.8031 19.079 26.9433C20.1506 28.0397 21.2399 29.1166 22.3204 30.2025C22.8234 30.7063 23.3194 31.2173 23.8065 31.7105C25.1686 30.3426 26.4881 29.0155 27.8626 27.6352V27.637Z" :fill="((post.is_reacted == 'pray') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="react d-flex align-items-center" :class="{'reacted': post.is_reacted}" style="margin-right: 15px;">
                    <div class="d-flex align-items-center" @click.stop="showReactMenu = !showReactMenu">
                        <div class="d-flex justify-self-center">
                            <svg v-if="!post.is_reacted || post.is_reacted === 'heart'"  width="18" height="16" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21.8032L10.3047 20.272C8.3724 18.522 6.96875 17.2277 6.09375 16.3892C5.21875 15.5506 4.23438 14.5116 3.14062 13.272C2.08333 12.0324 1.35417 10.9204 0.953125 9.93604C0.552083 8.9152 0.351562 7.87614 0.351562 6.81885C0.351562 5.03239 0.953125 3.51937 2.15625 2.27979C3.39583 1.0402 4.92708 0.42041 6.75 0.42041C8.86458 0.42041 10.6146 1.24072 12 2.88135C13.3854 1.24072 15.1354 0.42041 17.25 0.42041C19.0729 0.42041 20.5859 1.0402 21.7891 2.27979C23.0286 3.51937 23.6484 5.03239 23.6484 6.81885C23.6484 8.24072 23.1745 9.71729 22.2266 11.2485C21.2786 12.7798 20.2396 14.1105 19.1094 15.2407C18.0156 16.3709 16.2109 18.0662 13.6953 20.3267L12 21.8032Z" fill="currentColor"/>
                            </svg>

                            <svg v-else-if="post.is_reacted === 'pray'" width="18" height="16" viewBox="0 0 36 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.9968 1.28123C20.0001 -0.932971 23.4026 -0.0884525 24.1767 2.59945C24.3945 3.35881 24.4211 4.17671 24.5132 4.97155C24.8143 7.57608 25.1048 10.1824 25.3988 12.7887C25.6858 15.3435 25.9709 17.9002 26.2543 20.455C26.3589 21.3865 26.458 22.3161 26.5679 23.2476C26.5785 23.3434 26.6157 23.4499 26.6741 23.5261C27.4429 24.5002 28.2169 25.4689 29.0104 26.466C29.6233 26.0224 30.0732 26.262 30.5337 26.7286C32.188 28.3981 33.8689 30.041 35.5375 31.6963C36.1503 32.3031 36.1539 32.6899 35.5499 33.2949C33.1463 35.7078 30.7409 38.1207 28.332 40.5301C27.7333 41.1297 27.3738 41.1297 26.7769 40.5354C25.0729 38.8428 23.3708 37.1484 21.6721 35.4523C21.0912 34.8721 21.0876 34.5102 21.6615 33.9354C21.9856 33.6107 22.3275 33.3037 22.6321 33.0181C21.0362 31.4302 19.4882 29.8884 17.9525 28.3591C16.4966 29.8387 14.975 31.3876 13.3915 32.9968C13.6696 33.2665 14.031 33.5965 14.3711 33.946C14.867 34.457 14.8688 34.8473 14.3657 35.36C12.637 37.1236 10.9029 38.8818 9.16535 40.6365C8.68357 41.1226 8.24253 41.1209 7.75366 40.633C5.29694 38.1757 2.84199 35.7167 0.392342 33.2541C-0.133719 32.7254 -0.130177 32.3421 0.399427 31.8063C2.09806 30.0854 3.802 28.3679 5.50418 26.6505C6.01607 26.1342 6.23924 26.1023 6.94597 26.4536C7.72178 25.4813 8.50999 24.502 9.28402 23.512C9.36196 23.4126 9.38498 23.2582 9.39915 23.1252C9.71798 20.3166 10.0279 17.508 10.3485 14.6995C10.6709 11.875 11.0021 9.05044 11.3298 6.22591C11.4396 5.27849 11.5601 4.33284 11.6557 3.38365C11.8116 1.84542 12.5821 0.754291 14.031 0.236225C15.4781 -0.280066 16.7711 0.0588056 17.8533 1.1659C17.887 1.20139 17.9295 1.228 17.9968 1.283V1.28123ZM17.1749 14.7332C17.1749 14.538 17.1749 14.3713 17.1749 14.2027C17.1749 10.7767 17.1749 7.34898 17.1749 3.923C17.1749 3.78639 17.1803 3.64978 17.1679 3.51494C17.0793 2.47526 16.2769 1.69462 15.2691 1.65736C14.3161 1.62365 13.4217 2.35639 13.2977 3.30736C13.1436 4.48897 13.0178 5.67414 12.8832 6.85753C12.5963 9.39463 12.3146 11.9317 12.0259 14.4688C11.7372 17.0059 11.3918 19.5378 11.1669 22.0802C11.0517 23.3771 10.7772 24.5215 9.82602 25.4831C9.17598 26.1395 8.657 26.9273 8.10791 27.621C9.48417 29.0013 10.8179 30.3373 12.157 31.6804C12.1765 31.6679 12.2261 31.6466 12.2615 31.6129C13.8361 30.0339 15.4161 28.4584 16.9766 26.8652C17.1076 26.7321 17.1679 26.4766 17.1679 26.2779C17.1803 23.1411 17.1767 20.0044 17.1749 16.8675C17.1749 16.7185 17.1625 16.5695 17.1555 16.4205C16.1264 16.5056 15.5454 17.1372 15.5418 18.1752C15.5348 20.3911 15.5401 22.6071 15.5401 24.8231C15.5401 25.0041 15.5401 25.1832 15.5401 25.3536H13.9105C13.9105 22.9424 13.9105 20.5739 13.9105 18.2053C13.9105 16.2288 15.1256 14.9124 17.1767 14.7314L17.1749 14.7332ZM27.8626 27.637C27.0656 26.6363 26.2402 25.641 25.4661 24.6066C25.2252 24.2837 25.0269 23.8668 24.9737 23.4711C24.6974 21.3616 24.4742 19.245 24.2351 17.1301C23.7179 12.5633 23.2043 7.99479 22.6853 3.428C22.5418 2.17187 21.3498 1.38768 20.163 1.75849C19.3234 2.02106 18.8062 2.77155 18.8062 3.76333C18.8027 7.29221 18.8045 10.8211 18.8062 14.3517C18.8062 14.4813 18.8275 14.6108 18.8381 14.735C20.8786 14.9177 22.0707 16.2288 22.0707 18.255C22.0707 20.2155 22.0707 22.176 22.0707 24.1365C22.0707 24.541 22.0707 24.9455 22.0707 25.3624H20.4411C20.4411 25.1442 20.4411 24.9579 20.4411 24.7734C20.4411 22.5734 20.4464 20.3752 20.4393 18.1752C20.4358 17.1425 19.8407 16.4985 18.8328 16.4222C18.824 16.5038 18.8062 16.5855 18.8062 16.6671C18.8062 19.9068 18.8009 23.1465 18.8169 26.3844C18.8169 26.5724 18.9409 26.8031 19.079 26.9433C20.1506 28.0397 21.2399 29.1166 22.3204 30.2025C22.8234 30.7063 23.3194 31.2173 23.8065 31.7105C25.1686 30.3426 26.4881 29.0155 27.8626 27.6352V27.637Z" fill="currentColor"/>
                            </svg>

                            <svg v-else-if="post.is_reacted === 'cry'" width="18" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.38281 11.5C7.16406 10.9531 8.03646 10.6797 9 10.6797C9.96354 10.6797 10.8229 10.9531 11.5781 11.5C12.3594 12.0208 12.9193 12.7109 13.2578 13.5703H11.8906C11.2396 12.4766 10.276 11.9297 9 11.9297C7.72396 11.9297 6.76042 12.4766 6.10938 13.5703H4.74219C5.08073 12.7109 5.6276 12.0208 6.38281 11.5ZM4.27344 13.7266C5.60156 15.0286 7.17708 15.6797 9 15.6797C10.8229 15.6797 12.3854 15.0286 13.6875 13.7266C15.0156 12.3984 15.6797 10.8229 15.6797 9C15.6797 7.17708 15.0156 5.61458 13.6875 4.3125C12.3854 2.98438 10.8229 2.32031 9 2.32031C7.17708 2.32031 5.60156 2.98438 4.27344 4.3125C2.97135 5.61458 2.32031 7.17708 2.32031 9C2.32031 10.8229 2.97135 12.3984 4.27344 13.7266ZM3.10156 3.14062C4.74219 1.5 6.70833 0.679688 9 0.679688C11.2917 0.679688 13.2448 1.5 14.8594 3.14062C16.5 4.75521 17.3203 6.70833 17.3203 9C17.3203 11.2917 16.5 13.2578 14.8594 14.8984C13.2448 16.513 11.2917 17.3203 9 17.3203C6.70833 17.3203 4.74219 16.513 3.10156 14.8984C1.48698 13.2578 0.679688 11.2917 0.679688 9C0.679688 6.70833 1.48698 4.75521 3.10156 3.14062ZM5.17188 7.82812C4.9375 7.56771 4.82031 7.26823 4.82031 6.92969C4.82031 6.59115 4.9375 6.30469 5.17188 6.07031C5.43229 5.8099 5.73177 5.67969 6.07031 5.67969C6.40885 5.67969 6.69531 5.8099 6.92969 6.07031C7.1901 6.30469 7.32031 6.59115 7.32031 6.92969C7.32031 7.26823 7.1901 7.56771 6.92969 7.82812C6.69531 8.0625 6.40885 8.17969 6.07031 8.17969C5.73177 8.17969 5.43229 8.0625 5.17188 7.82812ZM11.0312 7.82812C10.7969 7.56771 10.6797 7.26823 10.6797 6.92969C10.6797 6.59115 10.7969 6.30469 11.0312 6.07031C11.2917 5.8099 11.5911 5.67969 11.9297 5.67969C12.2682 5.67969 12.5547 5.8099 12.7891 6.07031C13.0495 6.30469 13.1797 6.59115 13.1797 6.92969C13.1797 7.26823 13.0495 7.56771 12.7891 7.82812C12.5547 8.0625 12.2682 8.17969 11.9297 8.17969C11.5911 8.17969 11.2917 8.0625 11.0312 7.82812Z" fill="currentColor"/>
                            </svg>

                            <svg v-else-if="post.is_reacted === 'wow'" width="18" height="16" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="M20.979 0C9.387 0 0 9.408 0 21C0 32.592 9.387 42 20.979 42C32.592 42 42 32.592 42 21C42 9.408 32.592 0 20.979 0ZM21 37.8C11.718 37.8 4.2 30.282 4.2 21C4.2 11.718 11.718 4.2 21 4.2C30.282 4.2 37.8 11.718 37.8 21C37.8 30.282 30.282 37.8 21 37.8ZM28.35 18.9C30.093 18.9 31.5 17.493 31.5 15.75C31.5 14.007 30.093 12.6 28.35 12.6C26.607 12.6 25.2 14.007 25.2 15.75C25.2 17.493 26.607 18.9 28.35 18.9ZM13.65 18.9C15.393 18.9 16.8 17.493 16.8 15.75C16.8 14.007 15.393 12.6 13.65 12.6C11.907 12.6 10.5 14.007 10.5 15.75C10.5 17.493 11.907 18.9 13.65 18.9Z" :fill="((post.is_reacted == 'wow') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                                    <path d="M21.0002 35.7001C24.4796 35.7001 27.3002 32.8795 27.3002 29.4001C27.3002 25.9207 24.4796 23.1001 21.0002 23.1001C17.5208 23.1001 14.7002 25.9207 14.7002 29.4001C14.7002 32.8795 17.5208 35.7001 21.0002 35.7001Z" :fill="((post.is_reacted == 'wow') ? 'var(--buttons_color)' : '#CCCCCC')"/>
                                </g>
                            </svg>

                            <svg v-else width="18" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.82031 10.6797H13.1797C12.8411 11.6693 12.2943 12.4766 11.5391 13.1016C10.7839 13.7005 9.9375 14 9 14C8.0625 14 7.21615 13.7005 6.46094 13.1016C5.70573 12.4766 5.15885 11.6693 4.82031 10.6797ZM4.27344 13.7266C5.60156 15.0286 7.17708 15.6797 9 15.6797C10.8229 15.6797 12.3854 15.0286 13.6875 13.7266C15.0156 12.3984 15.6797 10.8229 15.6797 9C15.6797 7.17708 15.0156 5.61458 13.6875 4.3125C12.3854 2.98438 10.8229 2.32031 9 2.32031C7.17708 2.32031 5.60156 2.98438 4.27344 4.3125C2.97135 5.61458 2.32031 7.17708 2.32031 9C2.32031 10.8229 2.97135 12.3984 4.27344 13.7266ZM3.10156 3.14062C4.74219 1.5 6.70833 0.679688 9 0.679688C11.2917 0.679688 13.2448 1.5 14.8594 3.14062C16.5 4.75521 17.3203 6.70833 17.3203 9C17.3203 11.2917 16.5 13.2578 14.8594 14.8984C13.2448 16.513 11.2917 17.3203 9 17.3203C6.70833 17.3203 4.74219 16.513 3.10156 14.8984C1.48698 13.2578 0.679688 11.2917 0.679688 9C0.679688 6.70833 1.48698 4.75521 3.10156 3.14062ZM5.17188 7.82812C4.9375 7.56771 4.82031 7.26823 4.82031 6.92969C4.82031 6.59115 4.9375 6.30469 5.17188 6.07031C5.43229 5.8099 5.73177 5.67969 6.07031 5.67969C6.40885 5.67969 6.69531 5.8099 6.92969 6.07031C7.1901 6.30469 7.32031 6.59115 7.32031 6.92969C7.32031 7.26823 7.1901 7.56771 6.92969 7.82812C6.69531 8.0625 6.40885 8.17969 6.07031 8.17969C5.73177 8.17969 5.43229 8.0625 5.17188 7.82812ZM11.0312 7.82812C10.7969 7.56771 10.6797 7.26823 10.6797 6.92969C10.6797 6.59115 10.7969 6.30469 11.0312 6.07031C11.2917 5.8099 11.5911 5.67969 11.9297 5.67969C12.2682 5.67969 12.5547 5.8099 12.7891 6.07031C13.0495 6.30469 13.1797 6.59115 13.1797 6.92969C13.1797 7.26823 13.0495 7.56771 12.7891 7.82812C12.5547 8.0625 12.2682 8.17969 11.9297 8.17969C11.5911 8.17969 11.2917 8.0625 11.0312 7.82812Z" fill="currentColor"/>
                            </svg>
                        </div>
                        &nbsp;
                        <span>{{ totalReactions() }}</span>
                    </div>
                </div>
                <div v-if="!isMobile" @click="likePost(post.id)" class="like d-flex align-items-center" :class="{'liked' : post.is_liked}">
                    <svg width="19" height="16" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.5254 10.5688V12.9204C26.5254 13.2121 26.4707 13.5037 26.3613 13.7954L22.8066 21.9985C22.4421 22.9465 21.7311 23.4204 20.6738 23.4204H10.1738C9.55404 23.4204 9.00716 23.1834 8.5332 22.7095C8.05924 22.2355 7.82227 21.6886 7.82227 21.0688V9.42041C7.82227 8.80062 8.05924 8.25374 8.5332 7.77979L16.1895 0.0688477L17.4473 1.32666C17.7754 1.65479 17.9395 2.05583 17.9395 2.52979V2.9126L16.791 8.27197H24.1738C24.7936 8.27197 25.3405 8.50895 25.8145 8.98291C26.2884 9.42041 26.5254 9.94906 26.5254 10.5688ZM0.822266 23.4204V9.42041H5.52539V23.4204H0.822266Z" fill="currentColor"/>
                    </svg>
                    &nbsp;
                    <span v-if="post.is_liked">Curtido</span>
                    <span v-else>Curtir</span>
                </div>
            </div>
            <div v-if="isMobile" @click="likePost(post.id)" class="like d-flex align-items-center" :class="{'liked' : post.is_liked}">
                <svg width="19" height="16" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.5254 10.5688V12.9204C26.5254 13.2121 26.4707 13.5037 26.3613 13.7954L22.8066 21.9985C22.4421 22.9465 21.7311 23.4204 20.6738 23.4204H10.1738C9.55404 23.4204 9.00716 23.1834 8.5332 22.7095C8.05924 22.2355 7.82227 21.6886 7.82227 21.0688V9.42041C7.82227 8.80062 8.05924 8.25374 8.5332 7.77979L16.1895 0.0688477L17.4473 1.32666C17.7754 1.65479 17.9395 2.05583 17.9395 2.52979V2.9126L16.791 8.27197H24.1738C24.7936 8.27197 25.3405 8.50895 25.8145 8.98291C26.2884 9.42041 26.5254 9.94906 26.5254 10.5688ZM0.822266 23.4204V9.42041H5.52539V23.4204H0.822266Z" fill="currentColor"/>
                </svg>
            </div>
            <div class="comment d-flex align-items-center" :class="{ 'commenting': can_write_comment }" @click.stop="can_write_comment = !can_write_comment">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.3906 0.271973C22.0104 0.271973 22.5391 0.508952 22.9766 0.98291C23.4505 1.42041 23.6875 1.94906 23.6875 2.56885V16.5688C23.6875 17.1886 23.4505 17.7355 22.9766 18.2095C22.5391 18.6834 22.0104 18.9204 21.3906 18.9204H5.03906L0.390625 23.5688V2.56885C0.390625 1.94906 0.609375 1.42041 1.04688 0.98291C1.52083 0.508952 2.06771 0.271973 2.6875 0.271973H21.3906Z" fill="currentColor"/>
                </svg>
                &nbsp;
                <span v-if="!isMobile">Comentar</span>
            </div>
        </div>

        <div>
            <div class="comments d-flex" style="margin: 5px 0;">
                Comentários
            </div>
            
            <LmsFeedMore v-if="showMoreComments" ref="LmsFeedMore" :post="post" :open="openMoreComments" :loading="handleLoading" :isMobile="isMobile"></LmsFeedMore>

            <div v-if="post.total_comments > 0" class="d-flex align-items-center justify-content-between comment-item">
                <div class="d-flex align-items-center">
                    <img :src="post.last_comment.profile_photo_url" class="comment-user">
                    <div style="margin-left: 10px;">
                        <div class="d-flex align-items-center">
                            <div style="margin-left: 7px;"> <b class="username">{{ post.last_comment.username }} &nbsp;</b> <span class="comment-data" v-text="post.last_comment.time_ago"></span> </div>
                        </div>
                        <div v-text="post.last_comment.comment" class="comment-details" style="margin-left: 7px; overflow-wrap: break-word;"></div>
                    </div>
                </div>
                <div style="cursor: pointer;" class="comment-react">
                    <svg @click="likeComment(post.last_comment.id)" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path  d="M9.61523 16.9357L8.2832 15.7325C6.76497 14.3575 5.66211 13.3406 4.97461 12.6818C4.28711 12.0229 3.51367 11.2065 2.6543 10.2325C1.82357 9.25859 1.25065 8.38489 0.935547 7.61145C0.620443 6.80937 0.462891 5.99296 0.462891 5.16223C0.462891 3.75859 0.935547 2.56978 1.88086 1.59583C2.85482 0.621867 4.05794 0.134888 5.49023 0.134888C7.15169 0.134888 8.52669 0.779419 9.61523 2.06848C10.7038 0.779419 12.0788 0.134888 13.7402 0.134888C15.1725 0.134888 16.3613 0.621867 17.3066 1.59583C18.2806 2.56978 18.7676 3.75859 18.7676 5.16223C18.7676 6.27942 18.3952 7.43958 17.6504 8.6427C16.9056 9.84583 16.0892 10.8914 15.2012 11.7794C14.3418 12.6674 12.9238 13.9995 10.9473 15.7755L9.61523 16.9357Z" :fill="post.last_comment.liked ? '#E82E2E' : '#CCCCCC'"/>
                    </svg>
                    <br>
                    {{ post.last_comment.total_likes }}
                </div>
            </div>

            <div v-if="post.total_comments > 1" @click="openMoreComments(true, post.id)" class="see-more" style="margin: 5px 0;">
                {{ $i18n.t('posts.seeComments') }}
            </div>
        </div>

        <div style="margin: 12px 0">
            <div class="d-flex justify-content-between align-items-center comment-input" v-if="can_write_comment">
                <div style="width: 90%;">       
                    <input class="comment-input-text" maxlength="200" type="text" name="comment" id="comment-input" :placeholder="$i18n.t('posts.addComment')">
                </div>
                <div style="width: 10%; cursor: pointer;" :title="$i18n.t('posts.sendComment')" @click="sendComment(post.id)">
                    <svg width="100%" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 25%;">
                        <path d="M0.792215 15.5V9.67969L13.2922 8L0.792215 6.32031V0.5L18.2922 8L0.792215 15.5Z" fill="currentColor"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import LmsFeedMore from "@/components/lms/feed/components/LmsFeedMore.vue";

export default {
name: "LmsFeedPost",
props: ['loading', 'post', 'removePost', 'removeUser', 'isMobile'],
components: {
    LmsFeedMore,
},
data() {
    return {
        showMoreComments: false,
        showMoreMenu: false,
        showReactMenu: false,
        can_write_comment: false,
        fileName: '',
        fileSize: '',
    };
},
updated() {
    if(this.post.file_type == 'image' && this.post.photo_url != null) {
        let imageBack = this.post.photo_url;
        let div = document.getElementsByClassName('post-img-back');
        div.item(0).style.backgroundImage = `url(${imageBack})`;
    }
},
beforeMount() {

},
mounted() {

},
methods: {
    goToCommunity(val) {
        this.$router.push({ name: 'LmsCommunityFeed', params: { lmsSlug: this.$route.params.lmsSlug, communitySlug: val }})
    },
    handleLoading(status) {
        this.loading(status);
    },
    handleAction(action, id) {
        let root_ = this;
        let payload;
        this.showMoreMenu = false;
        root_.handleLoading(true);
        switch (action) {
            case 'send':
                payload = {
                    "friend_id": id,
                }
              root_.$store.dispatch('Friends/AddFriend', payload).then( response => {
                  response;
                  root_.post.is_friend = false;
                  root_.post.is_requested = false;
                  root_.post.is_requester = true;
                  root_.handleLoading(false);
              }).catch( error => {
                  error;
                  root_.handleLoading(false);
              });
              break;
          case 'cancel':
              if(confirm('Tem certeza que deseja cancelar o pedido de amizade?')) {
                payload = {
                    "friend_id": id,
                }
                  root_.$store.dispatch('Friends/RemoveFriend', payload).then( response => {
                      response;
                        root_.post.is_friend = false;
                        root_.post.is_requested = false;
                        root_.post.is_requester = false;
                    root_.handleLoading(false);
                  }).catch( error => {
                      error;
                      root_.handleLoading(false);
                  });
              }
              break;
          case 'accept':
                payload = {
                    "friend_id": id,
                }
                root_.$store.dispatch('Friends/AcceptRequest', payload).then( response => {
                    response;
                    root_.post.is_friend = true;
                    root_.post.is_requested = false;
                    root_.post.is_requester = false;
                    root_.handleLoading(false);
                }).catch( error => {
                    error;
                    root_.handleLoading(false);
                });
                break;
            case 'reject':
                payload = {
                    "friend_id": id,
                }
                root_.$store.dispatch('Friends/RejectRequest', payload).then( response => {
                    response;
                    root_.post.is_friend = false;
                    root_.post.is_requested = false;
                    root_.post.is_requester = false;
                    root_.handleLoading(false);
                }).catch( error => {
                    error;
                    root_.handleLoading(false);
                });
                break;
          case 'remove':
            if(confirm('Tem certeza que deseja desfazer a amizade?')) {
                payload = {
                    "friend_id": id,
                }
                    root_.$store.dispatch('Friends/RemoveFriend', payload).then( response => {
                        response;
                        root_.post.is_friend = false;
                        root_.post.is_requested = false;
                        root_.post.is_requester = false;
                        root_.handleLoading(false);
                    }).catch( error => {
                        error;
                        root_.handleLoading(false);
                    });
                }
                break;
            case 'report':
                if(!confirm('Tem certeza que deseja reportar essa publicação?')) return;

                payload = {
                    "post_id": id,
                }

                root_.$store.dispatch('Feed/reportPost', payload).then( response => {
                    console.log(response);
                    root_.removePost(id);
                    root_.handleLoading(false);
                }).catch( error => {
                    console.log('Error => ', error);
                    root_.handleLoading(false);
                });

                break;
            case 'block': 
                if(!confirm('Tem certeza que deseja bloquear esse usuário?')) return;

                payload = {
                    "friend_id": id,
                }

                root_.$store.dispatch('Friends/BlockUser', payload).then( response => {
                    console.log(response);
                    root_.removeUser(id);
                    root_.handleLoading(false);
                }).catch( error => {
                    console.log('Error => ', error);
                    root_.handleLoading(false);
                });

              break;
            case 'delete':
                if(!confirm('Tem certeza que deseja deletar essa publicação?')) return;
                
                payload = {
                    "post_id": id,
                }

                root_.$store.dispatch('Feed/deletePost', payload).then( response => {
                    console.log(response);
                    root_.removePost(id);
                    root_.handleLoading(false);
                }).catch( error => {
                    console.log('Error => ', error);
                    root_.handleLoading(false);
                });
                break;
            default:
                break;
        }
    },
    openMoreComments(status) {
        this.showMoreComments = status;

        if(status) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    },
    openLink(url) {
        window.open(url, '_blank');
    },
    downloadFile(url) {
      this.handleLoading(true);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.handleLoading(false);
    },
    reactPost(id, react) {
        let root_ = this;
        let payload = {
            "post_id": id,
            "reaction": react,
        }

        root_.handleLoading(true);

        this.$store.dispatch('Feed/reactPost', payload).then( response => {
            let reaction = response.data.post_reacted;
            let changed = response.data.changed;
            root_.post.is_reacted = reaction;
            if(reaction && !changed) {
                root_.post.total_reactions += 1;
            } else if(!changed) {
                root_.post.total_reactions -= 1;
            }
            root_.showReactMenu = false;
            root_.handleLoading(false);
        }).catch( error => {
            console.log('Error => ', error);
            root_.showReactMenu = false;
            root_.handleLoading(true);
        });
    },
    sendComment(id) {
        let root_ = this;
        root_.handleLoading(true);
        let input = document.getElementById('comment-input');
        let payload = {
            "post_id": id,
            "comment": input.value
        };

        this.$store.dispatch('Feed/storeComment', payload).then( response => {
            root_.post.total_comments += 1;
            root_.post.last_comment = response.data.comment;
            input.value = '';
            root_.can_write_comment = false;
            root_.handleLoading(false);
        }).catch( error => {
            console.log('Error => ', error);
            input.value = '';
            root_.can_write_comment = false;
            root_.handleLoading(false);
        });
    },

    likePost(id){
        let root_ = this;
        let payload = {
            "post_id": id
        };

        root_.handleLoading(true);

        this.$store.dispatch('Feed/likePost', payload).then( response => {
            let liked = response.data.post_liked;
            if(root_.post) {
                root_.post.is_liked = liked;
                if(liked) {
                    root_.post.total_reactions += 1;
                } else {
                    root_.post.total_reactions -= 1;
                }
            }
            root_.handleLoading(false);
        }).catch( error => {
            console.log('Error => ', error);
            root_.handleLoading(false);
        });
    },

    likeComment(id) {
        let root_ = this;
        let payload = {
            "comment_id": id
        };
        root_.handleLoading(true);
        this.$store.dispatch('Feed/likeComment', payload).then( response => {
            let liked = response.data.comment_liked;
            if(root_.post.last_comment) {
                root_.post.last_comment.liked = liked;
                if(liked) {
                    root_.post.last_comment.total_likes += 1;
                } else {
                    root_.post.last_comment.total_likes -= 1;
                }
            }
            root_.handleLoading(false);
        }).catch( error => {
            console.log('Error => ', error);
            root_.handleLoading(false);
        });
    },

    getFileName() {
        if(this.post.file_type == 'file') {
            if(this.isMobile) {
                return this.post.file_name.substring(0, 2) + '...';
            } else {
                return this.post.file_name;
            }
        }
    },

    getParsedUrl() {
        if(this.post.file_type == 'link') {
            const parsedURL = new URL(this.post.link);
            return parsedURL.origin;
        }
    },

    totalReactions(){
        let total = this.post.total_reactions;
        if(total == 1) {
            return total +' reação';
        } else {
            return total +' reações';
        }
    },
},
computed:{
    ...mapGetters([
        'avatar', 'nickname'
    ])
},
beforeDestroy() {

}

}

</script>
  
<style lang="scss">

.community-type {
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-weight: 300;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #706F6F;

    .community-name {
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0em;
        color: var(--buttons_color);

        &:hover {
            cursor: pointer;
            color: var(--buttons_color_2nd);
        }
    }
}

.document-download {
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0em;
    text-align: left;
    color: var(--buttons_color);

    span {
        margin-left: 5px;
    }

    &:hover {
        color: var(--buttons_color_2nd);
        cursor: pointer;
    }
}

.post-document-container {
    position: relative;
    max-width: 100%;
    min-width: 100%;
    margin: 10px 0;
    overflow: hidden;
    border: 1px solid #E1E1E1;

    .open-link-preview {
        svg {
            color: #B1B1B1;
            &:hover {
                color: var(--buttons_color);
                cursor: pointer;
            }
        }
    }

    .link-title {
        color: #706F6F;
        font-family: Hanken Grotesk;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .link-url, .link-desc {
        color: #706F6F;
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .post-link {
        max-width: 100%;
        min-width: 100%;

        .post-link-img {
            max-height: 300px !important;
            position: relative;
            width: 100%;
            height: auto;
            object-fit: scale-down;
            object-position: center;
        }
    }
}

.comment-item {
    margin: 14px 0;
    color: #706F6F;

    .comment-user {
        width: 58px;
        height: 58px; 
        border-radius: 50%;
        object-fit: contain;
        object-position: center;
    }
    .username {
        font-family: Hanken Grotesk;
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .comment-data {
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-weight: 300;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }
    
    .comment-details {
        font-family: Hanken Grotesk;
        font-size: 16px;
        font-weight: 300;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .comment-react {
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-weight: 300;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: center;
    }
}
.see-more {
    font-family: Hanken Grotesk;
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: #959595;

    &:hover {
        color: var(--fonts_color);
        cursor: pointer;
    }
}
.comment-input {
    font-family: Hanken Grotesk;
    color: var(--fonts_color);
    svg {
        color: var(--buttons_color);
    }
}
.comment-input-text {
    width: 100%;
    padding: 11px 12px 11px 12px;
    border-radius: 15px;
    border: 1px solid #34343440;
}
.comments {
    font-family: Hanken Grotesk;
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    color: var(--fonts_color);
}
.reactPostList
{
    display: flex;
    justify-content: space-between;
}
.reactPostList div
{
    margin: 0 8px;
    cursor: pointer;
}

.react,
.comment,
.like {
    color: #B1B1B1;
    font-family: Hanken Grotesk;
    font-size: 16px;
    line-height: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    svg {
        fill: #B1B1B1;
    }

    &:hover {
        color: #706F6F;
        font-weight: 700;
        cursor: pointer;

        svg {
            color: var(--buttons_color);
            fill: var(--buttons_color);
        }
    }
}

.reacted,
.commenting,
.liked {
    color: #706F6F !important;
    font-weight: 700 !important;

    svg {
        fill: var(--buttons_color) !important;
        color: var(--buttons_color) !important;
    }
}

.post-img-container {
    position: relative;
    max-width: 100%;
    min-width: 100%;
    margin: 10px 0;
    max-height: 420px;
    overflow: hidden; /* Certifica-se de que o desfoque fique contido dentro do contêiner */
}

.post-img {
    position: relative;
    z-index: 1; /* Garante que a imagem fique na frente do fundo desfocado */
    width: 100%;
    height: auto;
    object-fit: scale-down;
    object-position: center;
    max-height: 420px;
}

.post-img-back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(12px); /* Aplica o desfoque apenas ao fundo */
    z-index: 0; /* Garante que o fundo desfocado fique atrás da imagem */
}

.post-data {
    color: #706F6F;
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}
.post-details {
    margin: 10px 0;
    color: #706F6F !important;
    font-family: Hanken Grotesk !important;
    font-size: 16px !important;

    p {
        margin: 0;
        color: #706F6F !important;
        font-family: Hanken Grotesk !important;
        font-size: 16px !important;
        line-height: 18px !important;
    }
}


.more-actions {
    color: #B1B1B1;

    svg {
        fill: #B1B1B1;
    }

    &:hover {
        cursor: pointer;
        color: var(--buttons_color);
        svg {
            fill: var(--buttons_color);
        }
    }
}
.dropdown_menu {
    position: absolute;
    top: 100%;
    background-color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-wrap: nowrap;
    z-index: 100;
    overflow: hidden;
}
.dropdown_item {
    height: 35px;
    border: none;
    background-color: transparent;
    color: #B1B1B1;
    display: flex;
    align-items: center;
    width: cover;
    margin: 0px 5px;
    padding: 0px 7px;
    svg {
        fill: #B1B1B1;
    }
    &:hover {
        color: var(--buttons_color);
        svg {
            fill: var(--buttons_color);
        }
    }
}

.profile-img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
}

.nickname {
    color: #706F6F;
    font-family: Hanken Grotesk;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-left: 10px;
}

.publish-feed {
    width: 100%;
    border: none !important;
    border-radius: 30px;
    padding: 35px 80px;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.10);
}

.publish-feed.pinned {
    border: none !important;
    background-color: #FAF9FF !important;
}


@media only screen and (max-width: 1400px) {

}

@media only screen and (max-width: 1200px) {

}

@media only screen and (max-width: 992px) {

}
@media only screen and (max-width: 768px) {
    .publish-feed {
        padding: 30px 20px !important;
    }

    .profile-img {
        width: 48px !important;
        height: 48px !important;
    }

    .nickname {
        font-size: 14px !important;
    }

    .post-img-container {
        max-height: 260px !important;
    }

    .post-img {
        max-height: 260px !important;
    }

    .post-details {
        font-size: 14px !important;
    }

    .post-data {
        font-size: 12px !important;
    }

    .comments {
        font-size: 14px !important;
    }

    .see-more {
        font-size: 14px !important;
    }

    .comment-user {
        width: 48px !important;
        height: 48px !important;
    }
    .comment-data {
        font-size: 12px !important;
    }

    .username {
        font-size: 14px !important;
    }

    .comment-details {
        font-size: 14px !important;
    }
    .comment-react {
        font-size: 12px !important;
    }
    .link-title {
        font-size: 12px !important;
    }
    .link-url {
        font-size: 10px !important;
    }

    .post-link {
        max-height: 100px !important;
        .post-link-img {
            width: 90% !important;
            display: block !important;
            margin: 0 auto !important;
            max-height: 100px !important;
            object-fit: cover !important;
            object-position: center !important;
        }
    }

    .comment-input {
        font-size: 12px !important;
    }

    .comment-input-text {
        width: 100%;
        padding: 11px 12px 11px 12px;
        border-radius: 7px;
        border: 1px solid #34343440;
    }
}
@media only screen and (max-width: 480px) {
  
}

</style>